/* global axios */

import ApiClient from '../../ApiClient';

class UpdateLeadsToolAPI extends ApiClient {
  constructor() {
    super('integrations/mip/leads/update_leads_tool', { accountScoped: true });
  }

  // 获取 MIP 字段列表
  getFields() {
    return axios.get(`${this.url}/fields`);
  }

  // 获取本地配置
  getConfig() {
    return axios.get(`${this.url}/get_config`);
  }

  // 保存配置
  updateConfig(fields) {
    return axios.post(`${this.url}/update_config`, { fields });
  }

  // 同步检查字段变更
  sync() {
    return axios.post(`${this.url}/sync`);
  }
}

export default new UpdateLeadsToolAPI();
